import React from "react";
import { InputGroup as BootstrapInputGroup } from "react-bootstrap";
import styled, { css } from "styled-components";
import classNames from "classnames";
const StyledBootstrapInputAddon = ({ className = void 0, ...rest }) => /* @__PURE__ */ React.createElement(BootstrapInputGroup.Addon, { bsClass: className, ...rest });
export const StyledAddon = styled(StyledBootstrapInputAddon)(
  ({ theme }) => css`
    color: ${theme.colors.input.color};
    background-color: ${theme.colors.input.background};
    border-color: ${theme.colors.input.border};
  `
);
const Addon = ({ bsClass = "input-group-addon", className = void 0, ...addonProps }) => /* @__PURE__ */ React.createElement(StyledAddon, { className: classNames(bsClass, className), ...addonProps });
const Button = ({ bsClass = "input-group-btn", className = void 0, ...addonProps }) => /* @__PURE__ */ React.createElement(BootstrapInputGroup.Button, { bsClass: classNames(bsClass, className), ...addonProps });
const InputGroup = ({ bsClass = "input-group", className = void 0, ...restProps }) => /* @__PURE__ */ React.createElement(BootstrapInputGroup, { bsClass: classNames(bsClass, className), ...restProps });
InputGroup.Addon = Addon;
InputGroup.Button = Button;
export default InputGroup;
